import LocaleNumber from "components/ui/LocaleNumber";
import Badge from "hardcover-ui/components/Badge";
import pluralize from "lib/pluralize";
import { GoalSerializersGoalByline } from "types/serializers";

export default function GoalDaysLeftBadge({ goal }: { goal: GoalSerializersGoalByline }) {
  if (goal.daysLeft > 0) {
    return (
      <Badge size="sm" variant="secondary" className="hidden md:inline">
        <LocaleNumber number={goal.daysLeft} /> {pluralize("day", goal.daysLeft)} remaining
      </Badge>
    );
  }

  return false;
}
